import { isNull } from 'lodash-es'

import { Card, ZContractStatus } from '@/entities/contract'

import {
  HostPayInformationDetail,
  type Props as PayInformationDetailProps,
} from './detail'
import { GuestPayDeadline } from './guest-pay-deadline'

export type Props = PayInformationDetailProps & {
  payDeadlineTime: string | null
}

export const HostPayInformation = ({
  payDeadlineTime,
  ...restProps
}: Props) => {
  const showGuestPayDeadline =
    restProps.status === ZContractStatus.enum.PAY_READY &&
    !isNull(payDeadlineTime)

  return (
    <Card.Root spacing="large">
      {showGuestPayDeadline && (
        <GuestPayDeadline payDeadlineTime={payDeadlineTime} />
      )}
      <Card.Item>
        <Card.ItemTitle>정산금액</Card.ItemTitle>
        <Card.ItemContent className="space-y-3">
          <HostPayInformationDetail {...restProps} />
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
